import React, { FunctionComponent, useRef, useEffect } from 'react';
import { IconColor, IconName } from 'app/common/components/controls';
import { IconButton } from 'app/common/components/controls/button/button';

import { Noun, Verb } from '@trello/analytics';
import { track } from './Analytics';

import styles from './OnboardingDialog.less';

interface DialogProps {
  title: React.ReactNode;
  helpLink?: string;
  closeDialog: () => void;
  image?: HTMLImageElement;
}

export const OnboardingDialog: FunctionComponent<DialogProps> = ({
  title,
  helpLink,
  children,
  closeDialog,
  image,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  // Append pre-loaded image on mount
  useEffect(() => {
    if (ref.current && image) {
      ref.current.appendChild(image);
    }
  });

  return (
    <div ref={ref} className={styles.dialog}>
      <div className={styles.controls}>
        {helpLink && (
          <IconButton
            icon={IconName.Information}
            className={styles.icon}
            color={IconColor.Dark}
            largeIcon
            onClick={() => {
              track(
                Verb.OPENS,
                Noun.HELP_DOC_LINK,
                'by clicking overlay icon',
                {
                  url: helpLink,
                },
              );
              window.open(helpLink, '_blank');
            }}
          />
        )}
        <IconButton
          icon={IconName.Close}
          className={styles.icon}
          color={IconColor.Dark}
          largeIcon
          onClick={() => {
            track(
              Verb.DISMISSES,
              Noun.ONBOARDING_MENU,
              'by clicking dismiss button',
              {},
            );
            closeDialog();
          }}
        />
      </div>
      <div className={styles.content}>
        <header className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
        </header>
        <div>{children}</div>
      </div>
    </div>
  );
};
